<template>
  <div
    class="tab-pane"
    id="admission_detail_school_tab"
    aria-labelledby="admission-detail-school-tab"
  >
    <div class="my-3 mx-3">
      <div class="card">
        <label class="card-header text-center"
          ><strong>The Public Schools Placement Details</strong></label
        >
        <table class="table table-bordered table-striped" id="Org_Details">
          <thead>
            <tr>
              <th colspan="4" class="text-center">Student Information</th>
              <th colspan="6" class="text-center">Student Placement</th>
            </tr>
            <tr>
              <th>S.No</th>
              <th>Name of Student</th>
              <th>Index Number</th>
              <th>Dzongkhag</th>
              <th>School</th>
              <th>Dzongkhag</th>
              <th>School</th>
              <th>Class</th>
              <th>Stream</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in admission_details" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.std_indexno }}</td>
              <td>{{ item.dzongkhag }}</td>
              <td>{{ item.organization }}</td>
              <td>{{ item.placement_dzo }}</td>
              <td>{{ item.placement_org }}</td>
              <td>{{ item.class }}</td>
              <td>{{ item.stream }}</td>
              <td>{{ item.remarks }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showTable: false,
      user_type: "",
      admission_details: [],
      is_invalid: false,
      type: "admitted",
      dt:'',
    };
  },
  methods: {
    getDetails(dzo_id,organization_id) {
      axios
        .get("admissions/getAdmittedList/"  +dzo_id+'/'+ this.type  + "/" + organization_id)
        .then((res) => {
          let data = res.data;
          this.admission_details = data;
        })
        .catch((error) => console.log(error));
    },
  },
  mounted() {
    axios.get("getSessionDetail").then((response) => {
      let data = response.data.data;
      this.user_type = data["user_type"];
      this.getDetails(data["dzongkhag_id"],data["organization_id"]);
    });
  },
};
</script>
